import { Fragment } from "react";

import * as Cmp from "@impero-com/common/utils/comparison";

import { TagAndCategory } from "./tagAndCategory";
import { TagAndCategoryListContainer } from "./tagAndCategoryListContainer";

export function TagAndCategoryListFromRecord({
    tags,
}: {
    tags: Record<string, string[]>;
}) {
    const stringCompare = Cmp.string();
    const tagEntries = Object.entries(tags).toSorted(
        Cmp.map(([key]) => key, stringCompare)
    );
    if (tagEntries.length === 0) {
        return null;
    }
    return (
        <TagAndCategoryListContainer>
            {tagEntries.map(([key, values]) => (
                <Fragment key={key}>
                    {values.toSorted(stringCompare).map((value) => (
                        <TagAndCategory
                            key={`${key}:${value}`}
                            tagName={value}
                            categoryName={key}
                        />
                    ))}
                </Fragment>
            ))}
        </TagAndCategoryListContainer>
    );
}
